import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'
import { TRANSLATION_KEYS } from 'partner360/components/p360Access/components/retailAccessDenied/translations'
import { ProjectManagementIcon } from 'partner360/components/pmIcon/ProjectManagementIcon'

import styles from './RetailAccessDenied.module.scss'

export const RetailAccessDenied = () => {
  return (
    <div className={styles.root}>
      <Flex alignItems={'center'}>
        <ProjectManagementIcon />
        <div className={styles.warningMessage}>
          <Translation text={TRANSLATION_KEYS.warningMessage} />
          <div className={styles.message}>
            <Translation htmlAvailable text={TRANSLATION_KEYS.text} replaceParams={[]} />
          </div>
        </div>
      </Flex>
    </div>
  )
}
